<template>
  <orders-list v-if="ordersListNewLayoutEnabled" />
  <div v-else>
    <new-filter
      v-if="showFilter"
      ref="newFilter"
      origin="orders"
      :options="filterOptionsOrders"
      :additionalOptions="additionalOptions"
      :loadingList="loadingListOrders"
      :action="action"
      :sendFilterEvents="true"
    />

    <emd-alert
      v-if="report.alert.show"
      data-testid="alert_export_report_orders"
      :variant="report.alert.variant"
      @cancel="report.alert.show = false"
    >
      <template slot="content">
        <p>{{ $t(report.alert.title) }}</p>
      </template>
    </emd-alert>
    <orders-table :action="action">
      <template slot="header">
        <emd-card-header>
          <h2 class="emd-text _size_section">{{ $t('order.list.title') }}</h2>
          <template slot="actions">
            <report-button
              :loadingList="loadingListOrders"
              :report="report"
              :totalListItems="totalListItems"
            />
            <jade-button
              v-if="canShowShop"
              data-testid="btn_create_order"
              id="link-shop-orders"
              icon="plus"
              size="small"
              variant="primary-solid"
              @click="openShop"
            >
              {{ $t('btn-create') }}
            </jade-button>
          </template>
        </emd-card-header>
      </template>
    </orders-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { EmdAlert, EmdCardHeader } from 'emerald-vue/src/components'
import '@pagarme/orders-list/web-comp'
import { isOrdersListNewLayoutFlagEnabled } from '../../../feature-flags/orders-list.feature-flags'

import NewFilter from '@/components/project/globals/Filter/NewFilter.vue'
import ReportButton from '@/components/project/molecules/ReportButton.vue'
import { JadeButton } from '@/components/jade'
import { EXTERNAL_ENDPOINTS } from '@/external-endpoints'

import OrdersTable from './OrdersTable.vue'

import paymentSearchMixin from '../paymentSearch.mixin'

export default {
  components: {
    NewFilter,
    EmdAlert,
    EmdCardHeader,
    OrdersTable,
    ReportButton,
    JadeButton
  },
  mixins: [paymentSearchMixin],
  data () {
    return {
      isOrdersListNewLayoutFlagEnabled: false,
      action: 'GET_ORDERS',
      additionalOptions: {
        sort_mode: 'desc'
      },
      report: {
        action: 'SEND_ORDER_REPORT_FILE',
        loading: false,
        alert: {
          show: false
        },
        queryArray: ['ids', 'codes', 'customer_ids', 'status']
      }
    }
  },
  computed: {
    ...mapGetters([
      'accountId',
      'merchantId',
      'filterOptionsOrders',
      'orders',
      'orderIsEnabled',
      'loadingListOrders',
      'componentIsEnabled',
      'permissionIsEnabled'
    ]),
    showFilter () {
      return this.permissionIsEnabled('order:search')
    },
    ordersListNewLayoutEnabled () {
      return this.isOrdersListNewLayoutFlagEnabled
    },
    urlShop () {
      return EXTERNAL_ENDPOINTS.SHOP.url(this.merchantId, this.accountId)
    },
    canShowShop () {
      if (
        this.orderIsEnabled !== null &&
        this.permissionIsEnabled('shop.checkout:create') &&
        this.componentIsEnabled('apps', 'shop')
      ) {
        return this.orderIsEnabled
      }
      return false
    },
    totalListItems () {
      return this.orders.pagination.total_items
    }
  },
  async mounted () {
    this.isOrdersListNewLayoutFlagEnabled =
      await isOrdersListNewLayoutFlagEnabled()

    this.report = {
      ...this.report,
      enabled: this.permissionIsEnabled('order.report:export')
    }
  },

  methods: {
    shopTrack () {
      this.$gtag.event('click', {
        event_category: 'shopClick',
        event_label: 'Link shop página de pedidos'
      })
    },
    openShop () {
      this.shopTrack()
      window.open(this.$sanitize(this.urlShop), '_blank')
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "title": "Pedidos",
    "id": "ID",
    "code": "Código",
    "name": "Nome",
    "amount": "Valor",
    "status": "Status",
    "created-at": "Criado em",
    "btn-create": "Criar pedido",
    "report.success": "Em breve você receberá um e-mail com o link para download do arquivo.",
    "report.error": "Houve um erro no envio da sua requisição. Tente novamente mais tarde.",
    "report.limit": "Opa! Sua solicitação ultrapassou o nosso limite de 150.000 itens. Use o filtro para obter resultados mais objetivos e exporte novamente."
  },
  "en-US": {
    "title": "Orders",
    "id": "ID",
    "code": "Code",
    "name": "Name",
    "amount": "Amount",
    "status": "Status",
    "created-at": "Created",
    "btn-create": "Create order",
    "report.success": "Soon you will receive an email with the file download link.",
    "report.error": "There was an error sending your request. Try again later.",
    "report.limit": "Oops! Your request has exceeded our 150.000 items limit. Use the filter to get more objective results and export again."
  }
}
</i18n>
